
function Unauthorized() {
  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <h2>🚫 Bu səhifəyə giriş icazəniz yoxdur.</h2>
      <p>Zəhmət olmasa ana səhifəyə qayıdın və ya hesabınızla daxil olun.</p>
    </div>
  );
}

export default Unauthorized;
